module.exports = __webpack_public_path__ + "static/media/steps.4c29ba75.jpg";